export default function throttle(fn,delay){
    let lastTime, timer;
    return function(){
        let _this = this;
        let args = arguments;
        let nowTime = Date.now();
        if(lastTime && nowTime - lastTime < delay){
            if (timer) clearTimeout(timer);
            timer = setTimeout(function(){
                lastTime = nowTime;
                fn.apply(_this,args);
            },delay)
        }else{
            lastTime = nowTime;
            fn.apply(_this,args);
        }
    }
}
